(function tocScript($, Drupal, debounce, drupalSettings) {
  Drupal.behaviors.toc = {
    attach(context) {
      function setID(contentBody) {
        // @TODO Set ID for other heading h3, h4, etc.
        contentBody.find('h2').each(function () {
          let title = $(this).text();

          // Strip the unnecessary markup from WYSIWYG
          // MV. 6.27.19 - added regex function to strip all tags from title value. Tkt#: NOAA-3482
          title = title.replace('&nbsp;', ' ').replace("/[^A-Za-z0-9' –]/", '').replace(/<[^>]*>?/gm, '')
            .trim();
          // Prep the title for ID
          title = title.toLowerCase().split(' ').join('-');

          $(this).attr('id', title);
        });
      }

      function stickyScroll() {
        // Get the TOC element
        const TOC = $('.toc', context)[0];
        // Get the .row parent of the TOC element
        const TOCWrap = TOC.parentElement.parentElement;
        // Get some basic information about the bounding box on that parent.
        const TOCWrapRect = TOCWrap.getBoundingClientRect();
        // Get the actual TOC content on the page. This might not be the best way, but we need the height of the
        // content in the sibling column.
        const content = document.getElementsByClassName('toc-filter')[0];
        // Get the bounding box info for the content.
        const contentRect = content.getBoundingClientRect();
        // Set a variable that we'll use to check if our position on the page is between the top and bottom of the content.
        const contentSize = (contentRect.top - contentRect.bottom) + TOC.getBoundingClientRect().height;

        // If the TOCWrapRect's position from the top is less than 0 (going negative!) and we're within contentSize:
        // Just make it sticky.
        if (TOCWrapRect.top <= 0 && TOCWrapRect.top >= contentSize) {
          TOC.classList.remove('toc__sticky--bottom');
          TOC.classList.add('toc__sticky');
        }
        // If we're outside of the contentSize parameters, stick that sucker to the bottom of content size.
        else if (TOCWrapRect.top < contentSize) {
          TOC.classList.remove('toc__sticky');
          TOC.classList.add('toc__sticky--bottom');
        }
        // In any other case, just make things normal.
        else {
          TOC.classList.remove('toc__sticky');
          TOC.classList.remove('toc__sticky--bottom');
        }
      }

      const TOC = $('.toc', context)[0];
      const tocHeight = $('.toc', context).height();
      const windowHeight = window.innerHeight;

      // Make the menu sticky if the TOC menu's height is smaller than the window
      if (windowHeight > tocHeight) {
        // Run our sticky function once when the page loads if a TOC element is found.
        if (document.body.contains(TOC)) {
          stickyScroll();
        }

        const scrollChange = debounce(() => {
          (
            stickyScroll()
          );
        });

        if (document.body.contains(TOC)) {
          window.addEventListener('scroll', scrollChange, false);

          // Highlight nav links when scrolling the page
          window.addEventListener('scroll', () => {
            $('.toc-filter', context).find('h2').each(function () {
              const titleScroll = $(this).offset().top;

              // If you scroll by the title, add active class
              if (($(window).scrollTop() + 100) >= titleScroll) {
                const titleID = $(this).attr('id');

                if ($('.toc__list-link').hasClass('toc__list-link--active')) {
                  $('.toc__list-link').removeClass('toc__list-link--active');
                }

                $(`.toc__list-link[href="#${titleID}"]`).addClass('toc__list-link--active');
              }
            });
          });
        }
      }

      // Check to make sure drupalSettings variable is set to not throw any error
      if (drupalSettings.toc !== undefined) {
        // Get content type from drupalSettings variable
        const contentType = drupalSettings.toc.content_type;
        const contentBody = $(`.${contentType}__content`, context);

        // Create ID in headers if contentBody element exists
        if (document.body.contains(contentBody[0])) {
          // Using once() function to make sure our function is called only once
          contentBody.once('tocSetID', setID(contentBody));
        }
      }
    },
  };
}(jQuery, Drupal, Drupal.debounce, drupalSettings));
